export default __webpack_public_path__ + "static/accenture-detail-1-51e707ec4ad78e35aa3cd717b8f1f7ea.jpg";